import React, { useEffect, useState } from "react";

const getResponsiveStyle = (isMobile) => ({
  background: "#23272b",
  color: "#f8f9fa",
  fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
  fontSize: isMobile ? "0.86rem" : "0.95rem",
  padding: isMobile ? "0.5rem 0.5rem" : "0.75rem 1.5rem",
  width: "100vw",
  position: "relative",
  left: "50%",
  right: "50%",
  transform: "translateX(-50%)",
  textAlign: "center",
  letterSpacing: "0.01em",
  borderTop: "1px solid #343a40",
  fontStyle: "normal",
  borderRadius: 0,
  boxSizing: "border-box",
  margin: 0,
  maxWidth: "100vw"
});

const Disclaimer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div style={getResponsiveStyle(isMobile)}>
      * Estas declaraciones no han sido evaluadas por la Administración de Alimentos y Medicamentos (FDA). Este producto no está destinado a diagnosticar, tratar, curar ni prevenir ninguna enfermedad.
    </div>
  );
};

export default Disclaimer;
